import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider } from 'next-intl';
import { getMessages } from 'next-intl/server';
import { PropsWithChildren } from 'react';
export async function Layout(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = await getMessages();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const messages = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <NextIntlClientProvider messages={messages}>{children}</NextIntlClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}